module.exports = __webpack_public_path__ + "img/3.783cd6a4.png";